import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ModalService} from '../modal.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ParamService} from '../param.service';
import {BsModalRef} from 'ngx-bootstrap/modal/public_api';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    accessToken: string;
    banner: string;
    bsModalRef: BsModalRef;
    storeIdFromCart: any;
    storeIdFromParams: any;

    constructor(private modalService: ModalService,
                public activatedRoute: ActivatedRoute,
                private paramService: ParamService,
                private router: Router) {
        this.banner = this.paramService.banner;
        // console.log('constructor');
        this.activatedRoute.queryParams.subscribe(data =>
            this.storeIdFromCart = data.storeId);

        // The below is to capture routing events to get route params in Service
        this.router.events.subscribe((event: any) => {
            let r = this.activatedRoute;
            while (r.firstChild) {
                r = r.firstChild;
            }
            r.params.subscribe(params => {
                if (params.storeId) {
                    this.storeIdFromParams = params.storeId;
                }
            });
        });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(error => {
                if (error.status === 401) {
                    // this.routeService.routeToReSignIn();
                }
                return throwError(error);
            })
        );

    }

    // validate Request Url Needs ErrorModal or Not
    validateRequestUrl(request, error) {
        if (request.url.indexOf('payments/coa') >= -1 &&
            error.error.errorCode === 'OSMS_ORDERSERVICE_VALIDATION_ERROR' && error.status === 400) {
            return false;
        }
        return true;
    }
}

